const useBodyOverflowHidden = () => {
    return {
        hidden: () => (document.body.style.overflow = "hidden"),
        visible: () => (document.body.style.overflow = ""),
    };
};

export default useBodyOverflowHidden;
